import { Page } from "../templates/Page";
import { ContactHero } from "../organisms/ContactHero";
import { TalkToUs } from "../atoms/TalkToUs";
import { FindUsSection } from "../organisms/FindUsSection";
import { Spacer } from "../templates/Spacer";
import { Cloud } from "../atoms/Cloud";
import { FC } from "react";
import { LatestCaseStudy } from "utils/server";

export const ContactUs: FC<{
  latestCaseStudy: LatestCaseStudy;
}> = ({ latestCaseStudy }) => {
  return (
    <Page
      latestCaseStudy={latestCaseStudy}
      navColor="transparent"
      hero={<ContactHero title="Get in touch with us!" backgroundColor="#fefbe7" clouds={clouds} />}
      fullScreenHero
      showAnnouncementBar
    >
      <FindUsSection
        title="Where to find us"
        body={[
          "The Yuniverse is at the heart of Tech City - just by Old Street station in London.",
          "Here you'll find our vibrant little hub, spread out over a couple of floors with a little treehouse out back. We're close to Old Street, Liverpool Street Station, and Moorgate, making it an easy commute for most places in London.",
        ]}
        address="The Yuniverse, 12 Mallow St, London EC1Y 8RQ"
        link="Get directions"
      />
      <Spacer height={["0", "0", "5rem"]} />
      <TalkToUs pt="0" pb="0" />
      <Spacer height={["0", "0", "5rem"]} />
    </Page>
  );
};

export default ContactUs;

const clouds = (
  <>
    <Cloud id="Contact-hero-cloud1" scale={1.83} top="15%" left="20%" animated />
    <Cloud id="Contact-hero-cloud2" top="20%" right="20%" animated hideOnMobile />
    <Cloud id="Contact-hero-cloud3" scale={1.41} top="45%" right="15%" animated />
    <Cloud
      id="Contact-hero-cloud4"
      scale={0.8}
      reversed
      top="50%"
      left="15%"
      animated
      hideOnMobile
    />
  </>
);
